
import 'tinymce'

import './plugins'
import './theme'
import './icons'
import './styles'

import { addDamLoaderPlugin, hasDamLoaderPlugin } from './custom/plugins/damloader'

import { Editor } from '@tinymce/tinymce-react';
import { getConfigTinyMCE } from './config'
import { XGallery } from '@ximdex/xui-react/material'
import { getAllExistingMedia, postMediaToCMS } from '../../services/xevalApi.service'
import { MEDIA_PREVIEW, XDAM_URI_API } from '../../CONSTANTS'
import { useState } from 'react'
import { useEffect } from 'react'
import { useMemo } from 'react'

function EditorTinyMCE({handleEditorChange, config = {}, value, readonly, initialValue, language='en'}) {
  const configTinyMCE = getConfigTinyMCE({...config, language})
  const [isOpen, setOpen] = useState(false);
  const [editor, setEditor] = useState({})

  const handleSelectMediaGallery = ({url, type,  width, height, altText}) => {
    const str = type === 'image' 
    ? `<img src="${url}" alt="${altText ?? ''}" title="${altText ?? ''}" width="${width}" height="${height}"/>`
    : `<video controls><source src="${url}" type="video/mp4" alt="${altText ?? ''}" title="${altText ?? ''}"/></video>`
      
      editor?.insertContent(str);
      return {url, type,  width, height, altText}
  }

  const onChange = (...args) => {
    handleEditorChange(...args)
  }

  const toggleModal = () => setOpen(!isOpen)

  const hasDamLoader = useMemo(() => hasDamLoaderPlugin(configTinyMCE.plugins), [configTinyMCE.plugins])

  useEffect(() => {
    if (hasDamLoader) {
      addDamLoaderPlugin(toggleModal, setEditor)
    }
  }, [hasDamLoader])

  return (
    <> 
      <XGallery
        isGalleryOpen={isOpen}
        setIsGalleryOpen={setOpen}
        fetchMedia={getAllExistingMedia}
        selectMedia={handleSelectMediaGallery}
        addNewMedia={postMediaToCMS}
        mediaPreview={MEDIA_PREVIEW} 
        showExtraDetails
        hideAddNewMedia={XDAM_URI_API?.startsWith('http') ? false : true}
      />
      <Editor
        disabled={readonly}
        initialValue={initialValue ? initialValue : null}
        init={configTinyMCE}
        onEditorChange={onChange}
        value={value}
      />
    </>
  )
}

export default EditorTinyMCE
